

if (!customElements.get("product-form")) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.onSubmit.bind(this));
      this.querySelectorAll("[type='submit']").forEach((element) => {
        element.addEventListener("click", this.onClick.bind(this));
      });
      document
        .querySelectorAll(
          `[type='submit'][form='${this.form.getAttribute("id")}']`
        )
        .forEach((element) => {
          element.addEventListener("click", this.onClick.bind(this));
        });

      // Clear error message when variant options change
      this.addEventListener("change", this.clearErrorMessage.bind(this));
    }

    setSubmitted() {
      this.form.classList.add("submitted");
      document
        .querySelectorAll(`[form='${this.form.getAttribute("id")}']`)
        .forEach((element) => {
          element.classList.add("submitted");
        });
    }

    onClick(event) {
      this.setSubmitted();
      this.submitter = event.currentTarget;
    }

    async onSubmit(event) {
      event.preventDefault();

      //Check form submission method
      let submittedByDispatch = function(){
        if(event.target.classList.contains('shippingProtectionForm')){
          return true
        } else {
          return false
        }
      }

      let submittedByVariantPicker = function(){
        if(event.detail != null){
          return true
        } else {
          return false
        }
      }

      const data = new FormData(this.form);
      const variantId = data.get("id");

      // Check if required variant options are actually selected
      if (!this.areRequiredVariantOptionsSelected()) {
        this.handleErrorMessage(this.getVariantSelectionMessage());
        return;
      }
      
      if (this.submitting) {
        return;
      }

      this.submitting = true;

      event.submitter && (this.submitter = event.submitter);

      if (!submittedByDispatch() && !submittedByVariantPicker()) {
        const cartNotification = document.querySelector("cart-notification");
        if (cartNotification && typeof cartNotification.setActiveElement === 'function') {
          cartNotification.setActiveElement(document.activeElement);
        }
        this.submitter.setAttribute("aria-disabled", true);
        this.submitter.innerHTML = ("ADDING...");
      }

      let obj = { quantity: 1 };
      for (let [name, value] of data) {
        const path = name.split('.');
        
        let index = -1,
          length = path.length,
          lastIndex = length - 1,
          nestedObj = obj;

        while (++index < length) {
          let key = path[index],
          objValue = value;

          if (index != lastIndex) {
            objValue = nestedObj[key];
            
            objValue = typeof objValue === 'object'
              ? objValue
              : {};
          }
          nestedObj[key] = objValue;
          nestedObj = nestedObj[key];
        }
      }


      // Gift Card inputs
      const sendGiftCardToRecipent = data.get('properties[__shopify_send_gift_card_to_recipient]') ? data.get('properties[__shopify_send_gift_card_to_recipient]') : false;
      const giftCardRecipentEmail = data.get('properties[Recipient email]') ? data.get('properties[Recipient email]') : false;
      const giftcardRecipentName = data.get("properties[Recipient name]") ? data.get("properties[Recipient name]") : false;
      const giftcardRecipentMessage = data.get("properties[Message]") ? data.get("properties[Message]") : false;
      const giftcardImage = document.querySelector('.gift-card-preview-image')?.src;
      
      // Check if Automation & Threshold properties exist with this product and apply to product properties accordingly.
      const specialInput = data.get("properties[_Special]") ? data.get("properties[_Special]") : false;
      const thresholdInput = data.get("properties[_Threshold]") ? parseInt(data.get("properties[_Threshold]")) : 0;
      const discountInput = data.get("properties[_Discount]") ? parseInt(data.get("properties[_Discount]")) : 0;
      const keyInput = data.get("properties[_Key]") ? data.get("properties[_Key]") : false;

      let specialProps = {};
      if(specialInput)
        specialProps['_Special'] = specialInput

      if(thresholdInput)
        specialProps['_Threshold'] = thresholdInput

      if(discountInput)
        specialProps['_Discount'] = discountInput

      if(keyInput)
        specialProps['_Key'] = keyInput

      if( sendGiftCardToRecipent ){
        specialProps = data.get('properties[Recipient email]') ? { 
          'Message': giftcardRecipentMessage,
          'Recipient email' : giftCardRecipentEmail,
          'Recipent name' : giftcardRecipentName,
          '__image' : giftcardImage,
          '__shopify_send_gift_card_to_recipient' : sendGiftCardToRecipent
        } : {};
      }

      /* If Athlete is present, add the Athlete image. */
      const athleteInput = data.get("properties[Athlete]") ? data.get("properties[Athlete]") : false;
      if(athleteInput)
        specialProps['_Athlete'] = athleteInput;

      const config = window.fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      config.body = JSON.stringify({
        items: data.getAll("id").map((id) => ({
          ...obj,
          id,
          properties: specialProps
        })),
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      try {
       
        const response = await fetch(`${window.routes.cart_add_url}`, config);
        
        // Check if response is ok before parsing JSON
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
        }
        
        const json = await response.json();

        if (json.status) {
          this.handleErrorMessage(json.description || 'Failed to add item to cart');
        } else {
          try {
            this.renderLiveSections(json);
            if (typeof window.refreshCartFromServer === 'function') {
              await window.refreshCartFromServer();
            } else {
              const cart = await fetch('/cart.js', { method: 'GET' }).then((r) => r.json());
              if (typeof window.handleCartUpdated === 'function') {
                window.handleCartUpdated(cart);
              } else {
                window.cartJSON = cart;
              }
            }
          } catch (e) {
            console.error('Failed to update cartJSON after add to cart', e);
          }
        }
      } catch (error) {
        this.handleErrorMessage(`Failed to add item to cart: ${error.message}`);
      }


      if(submittedByVariantPicker()){
        setTimeout(()=>{
          if (typeof closeStickyVariantSelector === 'function') {
            closeStickyVariantSelector();
          }
        }, 1000)
      } else if (!submittedByDispatch()) {
        this.submitter.innerHTML = ("ADDED");
        this.submitter.classList.add("altLoader");
        setTimeout(()=>{
          this.delaySubmit(this.submitter)
        }, 1000)
      }

      // Check for AutoGift
      if (typeof window.runAutoGift === 'function') {
        await window.runAutoGift();
      }

      // Check for AutoDonation
      if (typeof window.runAutoDonation === 'function') {
        window.runAutoDonation();
      }

      this.submitting = false;
    }
  
    delaySubmit(submitter) {
      submitter.removeAttribute("aria-disabled");
      submitter.classList.remove("altLoader");
      submitter.setAttribute("added", "true");
      submitter.innerHTML = ("ADD TO CART")
    }

    onCartPage() {
      return window.location.pathname.startsWith(window.routes.cart_url);
    }

    isProductPage() {
      return this.getAttribute("data-form") === "product";
    }

    getSectionsToRender() {
      if (this.onCartPage()) {
        const cartItems = document.querySelector("cart-items");
        const sections = cartItems ? cartItems.getSectionsToRender() : [];
        return sections;
      } else {
        const cartDrawer = document.querySelector("cart-drawer");
        const sections = [];

        if (cartDrawer) {
          sections.push(
            { section: "cart-drawer" },
            { section: "cart-icon-bubble" }
          );
        }

        if (!this.isProductPage()) {
          const cartNotification = document.querySelector("cart-notification");
          if (cartNotification) {
            sections.push(...cartNotification.getSectionsToRender());
          }
        }
        
        return sections;
      }
    }

    renderLiveSections(json) {
      const cartDrawer = document.querySelector("cart-drawer");
      
      if (this.onCartPage()) {
        const cartItems = document.querySelector("cart-items");
        cartItems.currentItemCount += 1;
        cartItems.render(json);
      } else if (this.isProductPage()) {
        if (cartDrawer) {
          cartDrawer.renderContents(json);
        }
      } else {
        const cartNotification = document.querySelector("cart-notification");
        if (cartNotification) {
          setTimeout(() => { 
              cartNotification.renderContents(json) 
          }, 900);
        }

        if (cartDrawer) {
          cartDrawer.renderContents(json, false);
        }
      }
    }

    areRequiredVariantOptionsSelected() {
      // Check if we're on a product page with variants
      if (!document.body.classList.contains('template-product') || this.querySelector('.list-card-product')) {
        return true;
      }

      // Find variant selectors to check if options are selected
      // Note: variant selectors are siblings to product-form, not children
      const productInfoContainer = this.closest('.product__info-container');
      const variantRadios = productInfoContainer ? productInfoContainer.querySelector('variant-radios') : document.querySelector('variant-radios');
      const variantSelects = productInfoContainer ? productInfoContainer.querySelector('variant-selects') : document.querySelector('variant-selects');
      
      if (variantRadios) {
        // For radio button variant pickers - check visible fieldsets
        const fieldsets = variantRadios.querySelectorAll('fieldset:not(.hidden)');
        
        for (let fieldset of fieldsets) {
          // Check if this fieldset has any radio buttons with checked state
          const hasCheckedRadio = fieldset.querySelector('input:checked');
          if (!hasCheckedRadio) {
            return false;
          }
        }
      } else if (variantSelects) {
        // For dropdown variant pickers
        const selects = variantSelects.querySelectorAll('select[required]');
        for (let select of selects) {
          if (!select.value || select.value === '') {
            return false;
          }
        }
      }
      
      return true;
    }

    getVariantSelectionMessage() {
      // Find variant selectors to determine what options need to be selected
      // Note: variant selectors are siblings to product-form, not children
      const productInfoContainer = this.closest('.product__info-container');
      const variantRadios = productInfoContainer ? productInfoContainer.querySelector('variant-radios') : document.querySelector('variant-radios');
      const variantSelects = productInfoContainer ? productInfoContainer.querySelector('variant-selects') : document.querySelector('variant-selects');
      
      let unselectedOptions = [];
      
      if (variantRadios) {
        // For radio button variant pickers - check visible fieldsets
        const fieldsets = variantRadios.querySelectorAll('fieldset:not(.hidden)');
        
        fieldsets.forEach(fieldset => {
          const legend = fieldset.querySelector('legend span');
          const hasCheckedRadio = fieldset.querySelector('input:checked');
          
          if (!hasCheckedRadio && legend) {
            unselectedOptions.push(legend.textContent.trim());
          }
        });
      } else if (variantSelects) {
        // For dropdown variant pickers
        const selects = variantSelects.querySelectorAll('select[required]');
        selects.forEach(select => {
          const label = variantSelects.querySelector(`label[for="${select.id}"]`);
          
          if ((!select.value || select.value === '') && label) {
            unselectedOptions.push(label.textContent.trim());
          }
        });
      }
      
      if (unselectedOptions.length > 0) {
        // Create specific message based on unselected options
        if (unselectedOptions.length === 1) {
          return `Pick a ${unselectedOptions[0]}!`;
        } else {
          const lastOption = unselectedOptions.pop();
          return `Pick ${unselectedOptions.join(', ')} and ${lastOption}!`;
        }
      }
      
      // Fallback message
      return 'Please select a product option before adding to cart.';
    }

    clearErrorMessage() {
      this.handleErrorMessage(false);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector(".product-form__error-message-wrapper");
      
      if (!this.errorMessageWrapper) return;
      
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(".product-form__error-message");

      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }

  customElements.define("product-form", ProductForm);
}
